import type { HTTPMethod } from './essentials';

export class NetworkError extends Error {
  public readonly url: string;
  public readonly status: number;
  public readonly statusText: string;

  constructor(
    text: string,
    public readonly method: HTTPMethod,
    public readonly response: Response,
  ) {
    super(`Failed to ${method} ${response.url}: ${text}`);

    this.name = 'NetworkError';
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
  }
}
